import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "用户名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "remark", $$v);
      },
      expression: "searchForm.remark"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {};
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.addDialogVisible = true;
        _vm.phone = "";
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      "row-class-name": _vm.tableRowClassName,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: "姓名",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-table-user", {
          attrs: {
            info: scope.row,
            getData: _vm.getData
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "phone",
      label: "手机",
      width: "140"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "消息数",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-im-count", {
          attrs: {
            count: scope.row.imCount,
            userId: scope.row.id
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "imLikeCount",
      label: "获赞&评论",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "用户状态",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == "-1" ? _c("span", [_vm._v("已注销")]) : scope.row.isDefriend == "1" ? _c("span", [_vm._v("已拉黑")]) : _c("span", [scope.row.isDanger == 1 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("高危用户")]) : _c("span", [_vm._v("正常")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "gender",
      width: "80",
      label: "性别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.gender == 1 ? _c("span", [_vm._v("男")]) : scope.row.gender == 2 ? _c("span", [_vm._v("女")]) : _c("span", [_vm._v("男")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "age",
      width: "80",
      label: "年龄"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "occupation",
      width: "100",
      label: "职业"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "from",
      label: "来自",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "isRelease",
      label: "用户类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.houseReleaseState == 1 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "danger"
          }
        }, [_vm._v("房东ING")]) : _c("div", [scope.row.isRelease == 1 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("房客")]) : _vm._e(), scope.row.isRelease == 2 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "success"
          },
          on: {
            click: function click($event) {
              return _vm.goHouseList(scope.row);
            }
          }
        }, [_vm._v("房东")]) : _vm._e()], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "remark",
      label: "备注",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.remarkList,
            remark: scope.row.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "mail",
      label: "邮箱",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createTime",
      label: "注册时间",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "版本信息",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-app-version", {
          attrs: {
            info: scope.row.appInfo
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "120",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编辑")]), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setUserVip(scope.row.id, 0);
            }
          }
        }, [_vm._v("取消VIP")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "新增品牌季度用户",
      visible: _vm.addDialogVisible,
      width: "300px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.addDialogVisible = $event;
      }
    }
  }, [_c("el-form", [_c("el-form-item", [_c("el-input", {
    attrs: {
      placeholder: "请输入手机号"
    },
    model: {
      value: _vm.phone,
      callback: function callback($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.setUserVip();
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };